
import { IContactCategoryData } from 'src/app/common/models/IContactCategoryData';
import { IContactData } from 'src/app/common/models/IContactData';
import { IRecordsUpdate } from 'src/app/common/models/IRecordsUpdate';
import { ITagData } from 'src/app/common/models/ITagData';


export class SetRecordsUpdateData {
    static readonly type = '[IRecordsUpdate] Set RecordsOfUpdate Data';

    constructor(public recordsData: IRecordsUpdate) {}
}
export class SetContactUpdateData {
  static readonly type = '[IContactData] Set ContactUpdate Data';

  constructor(public contactData: IContactData) {}
}
export class SetContactCategoryUpdateData {
  static readonly type = '[IContactCategoryData] Set ContactCategoryUpdate Data';

  constructor(public contactCategoryData: IContactCategoryData) {}
}

export class SetTagUpdateData {
  static readonly type = '[ITagData] Set TagData Data';

  constructor(public tagData: ITagData) {}
}

export class ClearUpdateData {
    static readonly type = '[Settings] Clear Settings State';

    constructor() {}
}
